/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import lang from 'quasar/lang/es'



import {Notify,Loading,Dialog,LocalStorage,Meta} from 'quasar'



export default { config: {"loading":{"backgroundColor":"transparent","customClass":"snabb-loading","spinnerSize":0,"message":"<img src=\"img/snabb_loading.svg\" width=\"100%\" />","html":true},"notify":{"position":"top","progress":true},"capacitor":{"iosStatusBarPadding":true,"backButtonExit":"/"}},lang,plugins: {Notify,Loading,Dialog,LocalStorage,Meta} }

